module.exports = __webpack_public_path__ + "img/590a.54ffe408.png";